module.exports = __webpack_public_path__ + "img/icon54.b2bbea0a.png";